<template>
  <div>
    <v-row class="mx-2 mt-4">
      <v-col :cols="isMobile ? 12 : 3">
        <v-card class="mb-6">
          <AlertHeader title="1. Select Staff Category"></AlertHeader>
          <div class="px-4">
            <v-autocomplete
              label="Select Staff Category"
              :items="staffCategories"
              v-model="selectedStaffCategoryID"
              @input="getSelectedStaffCategory"
            ></v-autocomplete>
          </div>

          <div>
            <AlertHeader title="Click Button Below To Show Form"></AlertHeader>
            <v-row class="px-2 mb-4">
              <v-col :cols="6"
                ><v-btn
                  color="blue"
                  dark
                  @click="showCreateSalary()"
                  width="155"
                  >Create Salaries</v-btn
                ></v-col
              >
              <v-col :cols="6"
                ><v-btn color="warning" width="155" @click="showCreateRates()"
                  >Create Rates</v-btn
                ></v-col
              >
            </v-row>
            <v-row class="px-2 mb-4">
              <v-col :cols="6"
                ><v-btn
                  color="teal"
                  dark
                  width="155"
                  @click="showCreateEarning()"
                  >Apply Earnings</v-btn
                ></v-col
              >
              <v-col :cols="6"
                ><v-btn
                  color="brown"
                  width="155"
                  @click="showCreateDeduction()"
                  dark
                  >Apply Deductions</v-btn
                ></v-col
              >
            </v-row>
            <v-row class="px-2 mb-4">
              <v-col :cols="6"
                ><v-btn
                  color="black"
                  dark
                  width="155"
                  @click="openCreateStaffDialog()"
                  >Create Staff</v-btn
                ></v-col
              >
              <v-col :cols="6"
                ><v-btn
                  color="purple"
                  width="155"
                  @click="showCreateAgencyFee()"
                  dark
                  >Apply Agency Fee</v-btn
                ></v-col
              >
            </v-row>
          </div>
          <v-expansion-panels v-if="isMobile">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Create Staff Salary & Rates
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <AlertHeader
                  v-if="
                    !createSalaryContext &&
                    !createRatesContext &&
                    !createEarningContext &&
                    !createDeductionContext
                  "
                  title="Click Any Button Up To Show Form"
                ></AlertHeader>
                <v-card>
                  <div class="mb-4" v-if="createSalaryContext">
                    <AlertHeader title="Create Salary"></AlertHeader>
                    <CreateSalary
                      @salary-created="getNewlyCreatedSalary"
                    ></CreateSalary>
                  </div>

                  <div class="mb-4" v-else-if="createRatesContext">
                    <AlertHeader title="Create Staff Rate"></AlertHeader>
                    <CreateService
                      @service-created="getNewlyCreatedStaffRate"
                    ></CreateService>
                  </div>
                  <div v-else-if="createEarningContext">
                    <AlertHeader title="Add Earnings Or Bonuses"></AlertHeader>
                    <EariningsAndDeductions
                      :employeesIDs="selectedStaffIDs"
                      :payrollID="selectedPayroll"
                      selectedCategory="Other Earnings"
                      v-if="selectedStaffIDs.length"
                    ></EariningsAndDeductions>
                  </div>
                  <div v-else-if="createDeductionContext">
                    <AlertHeader title="Deduct From Staff"></AlertHeader>
                    <EariningsAndDeductions
                      :employeesIDs="selectedStaffIDs"
                      :payrollID="selectedPayroll"
                      selectedCategory="Deductions"
                      v-if="selectedStaffIDs.length"
                    ></EariningsAndDeductions>
                  </div>
                  <div v-else-if="createAndApplyPayrollContext">
                    <AlertHeader
                      title="Create & Add Staff To Payroll"
                    ></AlertHeader>
                    <ManagePayroll></ManagePayroll>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="mb-4" v-else>
            <div class="mb-4" v-if="createSalaryContext">
              <AlertHeader title="Create Salary"></AlertHeader>
              <CreateSalary
                @salary-created="getNewlyCreatedSalary"
              ></CreateSalary>
            </div>

            <div class="mb-4" v-else-if="createRatesContext">
              <AlertHeader title="Create Staff Rate"></AlertHeader>
              <CreateService
                @service-created="getNewlyCreatedStaffRate"
              ></CreateService>
            </div>
            <div v-else-if="createEarningContext">
              <AlertHeader title="Add Earnings Or Bonuses"></AlertHeader>
              <EariningsAndDeductions
                :employeesIDs="selectedStaffIDs"
                :payrollID="selectedPayroll"
                selectedCategory="Other Earnings"
                v-if="selectedStaffIDs.length"
              ></EariningsAndDeductions>
            </div>
            <div v-else-if="createDeductionContext">
              <AlertHeader title="Deduct From Staff"></AlertHeader>
              <EariningsAndDeductions
                :employeesIDs="selectedStaffIDs"
                :payrollID="selectedPayroll"
                selectedCategory="Deductions"
                v-if="selectedStaffIDs.length"
              ></EariningsAndDeductions>
            </div>
          </div>
        </v-card>
        <v-card>
          <v-expansion-panels v-if="isMobile">
            <v-expansion-panel>
              <v-expansion-panel-header>
                2. Select Staff From List
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <AlertHeader title="2. Select Staff From List"></AlertHeader>

                <StaffList
                  :employees="allStaff"
                  @selected-staff-from-staff-list="getSelectedStaffIDs"
                  @employee-profile-selected="getEmployeeProfile"
                ></StaffList>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-else>
            <StaffList
              :employees="allStaff"
              @selected-staff-from-staff-list="getSelectedStaffIDs"
              @employee-profile-selected="getEmployeeProfile"
            ></StaffList>
          </div>
        </v-card>
      </v-col>
      <v-col :cols="isMobile ? 12 : 3" class="px-2">
        <AlertHeader
          title="3. Steps To Generate Payroll & Payslips"
        ></AlertHeader>
        <v-card>
          <div>
            <v-btn
              class="mb-4"
              block
              x-large
              dark
              @click="openApplySalaryDialog()"
              color="#2E7D32"
              ><v-icon x-small>mdi-check</v-icon>1. Apply Salary To Selected
              Staff</v-btn
            >
          </div>

          <div>
            <v-btn
              class="mb-4"
              block
              x-large
              dark
              @click="openApplyRatesDialog()"
              color="blue"
              ><v-icon x-small>mdi-check</v-icon>2. Apply Rates To Selected
              Staff</v-btn
            >
          </div>
          <div>
            <v-btn
              class="mb-4"
              block
              x-large
              dark
              @click="openAddStaffToPayrollDialog()"
              color="warning"
              ><v-icon x-small>mdi-check</v-icon>3. Add Selected Staff To
              Payroll
            </v-btn>
          </div>
          <slot name="calendar"></slot>
        </v-card>
      </v-col>
      <v-col :cols="isMobile ? 12 : 6">
        <AlertHeader
          title="4. Manage Payroll, Payslips & Staff Profile"
        ></AlertHeader>
        <v-card
          ><v-row>
            <v-col :cols="isMobile ? 12 : 6"
              ><v-btn color="purple" @click="openShowOtherPayrollsDialog()" dark
                >Show Other Payrolls</v-btn
              ></v-col
            >
            <!-- <v-col :cols="isMobile ? 12 : 4">
              <v-btn color="primary" @click="showPayrollDetails()"
                >Show Payroll Details</v-btn
              >
            </v-col> -->
            <v-col :cols="isMobile ? 12 : 6"
              ><v-btn color="warning" @click="viewAndPrintPayslips()"
                >View & Print Payslips</v-btn
              ></v-col
            >
          </v-row></v-card
        >

        <v-card>
          <v-row>
            <v-col :cols="12">
              <div v-if="showPayrollContext">
                <Payroll
                  :payrollData="payrollData"
                  @selected-staff-from-payroll="getSelectedStaffForPayslips"
                ></Payroll>
              </div>
              <!-- <div v-else-if="showPayrollDetailsContext">
                <h1>showPayrollDetailsContext</h1>
              </div> -->
              <div
                v-else-if="
                  showViewAndPrintPayslipsContext && selectedStaffForPayslips
                "
              >
                <PayslipsPDF
                  :employeesOnPayroll="selectedStaffForPayslips"
                ></PayslipsPDF>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <GlobalDialogSlot
      :title="dilalogTitle"
      :dialog="dialog"
      @close-dialog="closeDialog"
    >
      <CreateStaff
        @staff-created="initialiseComponent"
        v-if="createStaffDialogContext"
      ></CreateStaff>
      <div v-else-if="applySalaryToStaffDialogContext" class="px-4">
        <v-row>
          <v-col :cols="12">
            <v-card-title
              >{{ selectedStaffIDs.length }} Staff Selected</v-card-title
            >
          </v-col>
        </v-row>
        <v-row>
          <SelectStaffSalary
            @salary-selected="getSelectedSalaryID"
          ></SelectStaffSalary>
        </v-row>

        <v-row class="mb-4 mt-4">
          <v-col :cols="6">
            <v-btn color="success" @click="applySalaryToStaff()"
              ><v-icon>mdi-check</v-icon>Apply Now</v-btn
            >
          </v-col>
        </v-row>
      </div>
      <div v-else-if="applyRateToStaffDialogContext" class="px-4">
        <FullCalendarForm></FullCalendarForm>
        <!-- <v-row>
          <v-col :cols="12">
            <v-card-title
              >{{ selectedStaffIDs.length }} Staff Selected</v-card-title
            >
          </v-col>
        </v-row>

        <v-row>
          <SelectStaffRate
            @rate-selected="getSelectedRateID"
            @agency-fee-selected="getSelectedAgencyFee"
          ></SelectStaffRate>
        </v-row>
        <v-row>
          <v-col :cols="12">
            <v-text-field label="Hours" v-model="hoursWorked"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mb-4 mt-4">
          <v-col :cols="6">
            <v-btn color="success" @click="applyRateToStaff()"
              ><v-icon>mdi-check</v-icon>Apply Now</v-btn
            >
          </v-col>
        </v-row> -->
      </div>
      <div v-else-if="addStaffToPayrollDialogContext">
        <v-row class="mx-4">
          <v-col :cols="12">
            <v-card-title
              >{{ selectedStaffIDs.length }} Staff Selected</v-card-title
            >
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col :cols="12">
            <v-select
              :items="payrollsFormatted"
              label="Select Payroll To Add Selected Staff To"
              v-model="selectedPayroll"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="ml-4 mb-4 mt-n2">
          <v-col>
            <v-btn color="success" @click="addSelectedStaffToAPayroll()"
              >Add Now</v-btn
            >
          </v-col>
        </v-row>
      </div>
      <div v-else-if="showOtherPayrollsDialogContext">
        <v-row class="mx-4">
          <v-col :cols="12">
            <v-select
              label="Select Payroll To View"
              :items="payrollsFormatted"
              v-model="selectedPayroll"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="ml-4 mb-4 mt-n2">
          <v-col>
            <v-btn color="success" @click="viewOtherPayroll()">View Now</v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="manageEmployeeProfileDialogContext">
        <StaffDetail :staff="selectedEmployee"></StaffDetail>
      </div>
    </GlobalDialogSlot>

    <GlobalConfirmDeleteDialog
      @delete-confirmed="deleteSelectedEmployeesNow"
      item="Selected Staff"
    ></GlobalConfirmDeleteDialog>
  </div>
</template>

<script>
import mainJs from "./main";
import AlertHeader from "./components/AlertHeader.vue";
import CreateStaff from "./components/CreateStaff.vue";
import GlobalDialogSlot from "./components/GlobalDialogSlot.vue";
import GlobalConfirmDeleteDialog from "./components/GlobalConfirmDeleteDialog.vue";
import StaffDetail from "./components/StaffDetail.vue";
import StaffList from "./components/StaffList.vue";
import CreateSalary from "./components/CreateSalary.vue";
import SelectStaffSalary from "./components/SelectStaffSalary.vue";
import CreateService from "./components/CreateService.vue";
import SelectStaffRate from "./components/SelectStaffRate.vue";
import EariningsAndDeductions from "./components/EariningsAndDeductions.vue";
import CreatePayroll from "./components/CreatePayroll.vue";
import Payroll from "./components/Payroll.vue";
import PayslipsPDF from "./components/PayslipsPDF.vue";

export default {
  components: {
    AlertHeader,
    CreateSalary,
    CreateStaff,
    GlobalDialogSlot,
    StaffList,
    GlobalConfirmDeleteDialog,
    CreateService,
    EariningsAndDeductions,
    CreatePayroll,
    Payroll,
    SelectStaffSalary,
    SelectStaffRate,
    StaffDetail,
    PayslipsPDF,
  },
  props: {
    branchID: {
      default: null,
    },
    conferenceID: {
      default: null,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getAllStaffRoute() {
      return this.$store.getters.getAllStaffRoute;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getRetrieveAllPayrollsRoute() {
      return this.$store.getters.getRetrieveAllPayrollsRoute;
    },
    getDeleteEmployeesRoute() {
      return this.$store.getters.getDeleteEmployeesRoute;
    },
    getAddSelectedStaffToAPayrollRoute() {
      return this.$store.getters.getAddSelectedStaffToAPayrollRoute;
    },
    getApplySalaryToSelectedStaffRoute() {
      return this.$store.getters.getApplySalaryToSelectedStaffRoute;
    },
    getApplyRateToSelectedStaffRoute() {
      return this.$store.getters.getApplyRateToSelectedStaffRoute;
    },
    getRetrieveAllStaffCategoriesRoute() {
      return this.$store.getters.getRetrieveAllStaffCategoriesRoute;
    },
  },
  async mounted() {
    await this.getAllStaff();
    const payrolls = await this.getAllPayrolls();
    await this.addSelectedStaffToAPayroll();
    await this.getAllStaffCategories();
    this.getPayrolls(payrolls);
  },
  data: () => ({
    dilalogTitle: "Title",
    dialog: false,
    addStaffToPayrollDialogContext: false,
    createStaffDialogContext: false,
    applySalaryToStaffDialogContext: false,
    applyRateToStaffDialogContext: false,
    showOtherPayrollsDialogContext: false,
    manageEmployeeProfileDialogContext: false,
    staffCategories: [],
    selectedStaffCategoryID: null,
    allStaff: [],
    selectedStaff: [],
    selectedStaffIDs: [],
    salaries: [],
    selectedSalaryID: null,
    rates: [],
    selectedRateID: null,
    hoursWorked: 1,
    showPayrollContext: true,
    createSalaryContext: false,
    createRatesContext: false,
    createEarningContext: false,
    createDeductionContext: false,
    createAndApplyPayrollContext: false,
    showPayrollDetailsContext: false,
    showViewAndPrintPayslipsContext: false,
    createAgencyFeeContext: false,
    payrollsOriginal: [],
    payrollsFormatted: [],
    selectedStaffForPayslips: [],
    payrollHeaders: [
      { text: "Year", value: "year" },
      { text: "Month", value: "month" },
      { text: "Pay Date", value: "pay_date" },
      { text: "Total Earnings", value: "total_earnings" },
      { text: "Total Paye", value: "total_paye" },
      { text: "Total Deductions", value: "total_deductions" },
      { text: "Total Salary Paid", value: "total_salary_paid" },
      { text: "Total Earnings", value: "total_earnings" },
    ],
    payrollData: null,
    selectedPayroll: null,
    selectedStaffObj: null,
    selectedEmployee: null,
    selectedAgencyFee: null,
  }),
  methods: {
    async initialiseComponent(staff) {
      this.$store.commit("setLoader", true);
      await this.getAllStaff();
      this.$store.commit("setLoader", false);
    },
    async getAllStaffCategories() {
      const staffCategories = await mainJs.getAllStaffCategories(
        this.getApiUrl + this.getRetrieveAllStaffCategoriesRoute,
        this.getAccessToken
      );

      if (staffCategories.length > 0) {
        this.staffCategories = [];
        staffCategories.forEach((sc) => {
          this.staffCategories.push({
            text: sc.name,
            value: sc.id,
          });
        });
      }
    },
    getSelectedStaffCategory() {
      const allStaff = this.allStaff;

      this.allStaff = this.allStaff.filter((allSt) => {
        return allSt.staff_category_id == this.selectedStaffCategoryID;
      });
    },
    async getAllPayrolls() {
      this.$store.commit("setLoader", true);
      const payrolls = await mainJs.getAllPayrolls(
        this.getApiUrl + this.getRetrieveAllPayrollsRoute,
        this.getAccessToken
      );
      this.$store.commit("setLoader", false);
      return payrolls;
    },
    getPayrolls(payrolls) {
      if (payrolls.length > 0) {
        this.payrollsOriginal = payrolls;
        this.payrollsFormatted = [];
        payrolls.forEach((payroll) => {
          this.payrollsFormatted.push({
            text: `${payroll.name} Payroll`,
            value: payroll.id,
          });
        });
      }
    },
    async viewOtherPayroll() {
      this.$store.commit("setLoader", true);
      await this.addSelectedStaffToAPayroll();
      this.$store.commit("setLoader", false);
      this.closeDialog();
    },
    async getAllStaff() {
      this.allStaff = await mainJs.getAllStaff(
        this.getApiUrl + this.getAllStaffRoute,
        this.getAccessToken
      );
    },
    getNewlyCreatedSalary(salary) {
      this.salaries.unshift({
        text: `${salary.name} [${this.getCurrency}${salary.amount}]`,
        value: salary,
      });
    },
    getNewlyCreatedStaffRate(rate) {
      this.rates.unshift({
        text: rate.name + " | " + this.getCurrency + rate.price,
        value: `${rate.id}-${rate.price}`,
      });
    },
    getSelectedSalary(salaryID) {
      this.selectedSalary = salaryID;
    },
    getSelectedStaffIDs(selectedStaffIDs) {
      this.selectedStaffIDs = selectedStaffIDs;
    },
    getSelectedStaffForPayslips(selectedStaffForPayslips) {
      this.selectedStaffForPayslips = selectedStaffForPayslips;
    },
    openApplyRatesDialog() {
      this.closeDialog();
      this.dilalogTitle = "Select Staff & Apply Rate";
      this.applyRateToStaffDialogContext = true;
      this.dialog = true;
    },
    openApplySalaryDialog() {
      if (this.checkStaffSelected()) {
        this.closeDialog();
        this.dilalogTitle = "Apply Salary To Selected Staff";
        this.applySalaryToStaffDialogContext = true;
        this.dialog = true;
      }
    },
    openCreateStaffDialog() {
      this.closeDialog();
      this.createStaffDialogContext = true;
      this.dilalogTitle = "Create Staff";
      this.dialog = true;
    },
    openAddStaffToPayrollDialog() {
      if (this.checkStaffSelected()) {
        this.closeDialog();
        this.dilalogTitle = "Add Selected Staff To A Payroll";
        this.addStaffToPayrollDialogContext = true;
        this.dialog = true;
      }
    },
    getSelectedSalaryID(selectedSalaryID) {
      this.selectedSalaryID = selectedSalaryID;
    },
    getSelectedRateID(selectedRateID) {
      this.selectedRateID = selectedRateID;
    },
    async applySalaryToStaff() {
      this.$store.commit("setLoader", true);
      const staff = await mainJs.applySalaryToStaff(
        this.getApiUrl + this.getApplySalaryToSelectedStaffRoute,
        this.selectedStaffIDs,
        this.selectedSalaryID,
        this.getAccessToken
      );
      this.allStaff = staff;
      this.$store.commit("setLoader", false);
      this.$toast.success("Salary Applied Successfully To Selected Staff!", {
        duration: 3000,
      });
    },
    async applyRateToStaff() {
      this.$store.commit("setLoader", true);

      const selectedRate = this.selectedRateID.split("-");
      const selectedRateID = selectedRate[0];

      const agencyFee = (
        Number(this.selectedAgencyFee.percentage) *
        Number(mainJs.stripCommasFromMoney(selectedRate[1]))
      ).toFixed(2);

      const total = (
        Number(this.hoursWorked) *
        Number(mainJs.stripCommasFromMoney(selectedRate[1]))
      ).toFixed(2);

      const staff = await mainJs.applyRateToStaff(
        this.getApiUrl + this.getApplyRateToSelectedStaffRoute,
        this.selectedStaffIDs,
        selectedRateID,
        this.hoursWorked,
        total,
        this.payrollMonth,
        agencyFee,
        this.selectedAgencyFee.name,
        this.getAccessToken
      );
      this.selectedAgencyFee = null;
      this.allStaff = staff;
      this.$store.commit("setLoader", false);
      this.closeDialog();
      this.$toast.success("Rate Successfully Captured!", { duration: 3000 });
    },
    async deleteSelectedEmployeesNow(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        this.employees = await mainJs.deleteSelectedEmployeesNow(
          this.getApiUrl + this.getDeleteEmployeesRoute,
          this.selectedStaffIDs,
          this.getAccessToken
        );

        this.$store.commit("setLoader", false);
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
    showCreateSalary() {
      this.createRatesContext = false;
      this.createEarningContext = false;
      this.createDeductionContext = false;
      this.createAndApplyPayrollContext = false;
      this.showPayrollDetailsContext = false;
      this.showViewAndPrintPayslipsContext = false;

      this.createAgencyFeeContext = false;
      this.createSalaryContext = true;
    },
    showCreateRates() {
      this.createSalaryContext = false;
      this.createEarningContext = false;
      this.createDeductionContext = false;
      this.createAndApplyPayrollContext = false;
      this.showPayrollDetailsContext = false;
      this.showViewAndPrintPayslipsContext = false;

      this.createAgencyFeeContext = false;
      this.createRatesContext = true;
    },
    showCreateEarning() {
      if (this.checkStaffSelected()) {
        this.createSalaryContext = false;
        this.createRatesContext = false;
        this.createDeductionContext = false;
        this.createAndApplyPayrollContext = false;
        this.showPayrollDetailsContext = false;
        this.showViewAndPrintPayslipsContext = false;

        this.createAgencyFeeContext = false;
        this.createEarningContext = true;
      }
    },
    showCreateDeduction() {
      if (this.checkStaffSelected()) {
        this.createSalaryContext = false;
        this.createRatesContext = false;
        this.createEarningContext = false;
        this.createAndApplyPayrollContext = false;
        this.showPayrollDetailsContext = false;
        this.showViewAndPrintPayslipsContext = false;

        this.createAgencyFeeContext = false;
        this.createDeductionContext = true;
      }
    },
    showCreateAgencyFee() {
      if (this.checkStaffSelected()) {
        this.createSalaryContext = false;
        this.createRatesContext = false;
        this.createEarningContext = false;
        this.createAndApplyPayrollContext = false;
        this.showPayrollDetailsContext = false;
        this.showViewAndPrintPayslipsContext = false;

        this.createDeductionContext = false;
        this.createAgencyFeeContext = true;
      }
    },
    openShowOtherPayrollsDialog() {
      this.closeDialog();
      this.showPayroll();
      this.showOtherPayrollsDialogContext = true;
      this.dilalogTitle = "Select Other Payrolls To View";
      this.dialog = true;
    },
    showPayroll() {
      this.createSalaryContext = false;
      this.createRatesContext = false;
      this.createEarningContext = false;
      this.createAndApplyPayrollContext = false;
      this.showPayrollDetailsContext = false;
      this.showViewAndPrintPayslipsContext = false;
      this.createDeductionContext = false;
      this.createAgencyFeeContext = false;
      this.showPayrollContext = true;
    },
    showPayrollDetails() {
      if (!this.selectedPayroll) {
        alert("Select A Payroll To View Details");
        return false;
      }
      this.createSalaryContext = false;
      this.createRatesContext = false;
      this.createEarningContext = false;
      this.createDeductionContext = false;
      this.createAndApplyPayrollContext = false;
      this.showViewAndPrintPayslipsContext = false;
      this.showPayrollContext = false;
      this.createAgencyFeeContext = false;
      this.showPayrollDetailsContext = true;
    },
    viewAndPrintPayslips() {
      // if (!this.selectedStaffObj) {
      //   alert("Select A Staff To View Profile");
      //   return false;
      // }
      this.createSalaryContext = false;
      this.createRatesContext = false;
      this.createEarningContext = false;
      this.createDeductionContext = false;
      this.createAndApplyPayrollContext = false;
      this.showPayrollDetailsContext = false;
      this.showPayrollContext = false;
      this.createAgencyFeeContext = false;
      this.showViewAndPrintPayslipsContext = true;
    },
    checkStaffSelected() {
      if (this.selectedStaffIDs.length < 1) {
        alert("Select At Least 1 Staff");
        return false;
      } else {
        return true;
      }
    },
    async addSelectedStaffToAPayroll() {
      const payslips = await mainJs.addSelectedStaffToAPayroll(
        this.getApiUrl + this.getAddSelectedStaffToAPayrollRoute,
        this.selectedStaffIDs,
        this.selectedPayroll,
        this.getAccessToken
      );
      this.payrollData = payslips;
      this.selectedStaffForPayslips = payslips.employees;
    },
    async payrollDeleted() {
      const payrolls = await this.getAllPayrolls();
      this.getPayrolls(payrolls);
    },
    selectAllStaff() {
      //not used yet
      if (this.selectAll) {
        this.selectedStaffIDs = [];
        this.allStaff.forEach((staf) => {
          this.selectedStaffIDs.push(staf.id);
        });
      } else {
        this.selectedStaffIDs = [];
      }
    },
    getEmployeeProfile(selectedEmployee) {
      this.selectedEmployee = selectedEmployee;
      this.closeDialog();
      this.manageEmployeeProfileDialogContext = true;
      this.dilalogTitle = selectedEmployee.name + " Profile";
      this.dialog = true;
    },
    getSelectedAgencyFee(selectedAgencyFee) {
      this.selectedAgencyFee = selectedAgencyFee;
    },
    closeDialog() {
      this.dialog = false;

      this.dilalogTitle = "Title";
      this.manageEmployeeProfileDialogContext = false;
      this.addStaffToPayrollDialogContext = false;
      this.createStaffDialogContext = false;
      this.applySalaryToStaffDialogContext = false;
      this.applyRateToStaffDialogContext = false;
      this.showOtherPayrollsDialogContext = false;
    },
  },
};
</script>
